var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99365 12.8154C3.59766 12.8154 0.842773 10.0605 0.842773 6.66455C0.842773 3.26855 3.59766 0.513672 6.99365 0.513672C10.3896 0.513672 13.1445 3.26855 13.1445 6.66455C13.1445 10.0605 10.3896 12.8154 6.99365 12.8154ZM6.99365 11.73C9.79297 11.73 12.0591 9.46387 12.0591 6.66455C12.0591 3.86523 9.79297 1.59912 6.99365 1.59912C4.19434 1.59912 1.93457 3.86523 1.93457 6.66455C1.93457 9.46387 4.19434 11.73 6.99365 11.73ZM3.88965 7.34375C3.64209 7.34375 3.45166 7.15332 3.45166 6.90576C3.45166 6.66455 3.64209 6.47412 3.88965 6.47412H6.55566V2.89404C6.55566 2.65283 6.74609 2.4624 6.9873 2.4624C7.23486 2.4624 7.43164 2.65283 7.43164 2.89404V6.90576C7.43164 7.15332 7.23486 7.34375 6.9873 7.34375H3.88965Z",
    fill: "#0A84FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueClock);
export default __webpack_public_path__ + "static/media/blueClock.caa02f27dbd04d8f75828a74e6591fdd.svg";
export { ForwardRef as ReactComponent };